import React, { useEffect } from "react";
import { SaleStep } from "../../../store/stepSaleConfig/stepSaleConfigReducer";
import useEvents from "../../EventSale/hooks/useEvents";
import EventSingle from "../../EventSale/SingleEvent";
import EASkeletonLoader from "../../shared/EASkeletonLoader";

interface IProps {
  saleStep: SaleStep;
}

const EventModule: React.FC<IProps> = ({ saleStep }) => {
  const { getEventExercises, exercise, loading } = useEvents();

  useEffect(() => {
    getEventExercises(saleStep.exerciseName, saleStep.exerciseIds, saleStep.exerciseGroupIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const highlightedFeatures = [
    saleStep.highlightedFeature1,
    saleStep.highlightedFeature2,
    saleStep.highlightedFeature3,
  ].filter(Boolean);

  if (loading) return <EASkeletonLoader height="200px" />;

  if (exercise.length > 0)
    return (
      <div className="module-list">
        {exercise.map((item, index) => (
          <EventSingle item={item} key={index} saleStep={saleStep} highlightedFeatures={highlightedFeatures} />
        ))}
      </div>
    );

  return <></>;
};

export default EventModule;
